import {ScriptsProvider} from '../providers/scriptsProvider';

class LazyOnlineConsultant
{
    static load() {
        let onlineConsultantMeta = document.querySelector('[data-script="online-consultant"]');

        if (onlineConsultantMeta) {
            ScriptsProvider.addWithAttributes('https://code.jivosite.com/widget.js', {
                'data-jv-id': onlineConsultantMeta.getAttribute('data-id'),
            });
        }
    }
}

export {LazyOnlineConsultant};
